import React from 'react';

import { Typography } from '@mui/material';

export default function LensProposalPreview() {
  return <Typography variant="body2">This earlier draft was never applied. Ask again to apply it.</Typography>;
}
